import { useAddToCartButton } from '../hooks/useAddToCartButton';

type ButtonDataContainerProps = { children: React.ReactNode };

const ButtonDataContainer = ({ children }: ButtonDataContainerProps) => {
	const { blockClass, componentId } = useAddToCartButton();

	return (
		<div
			data-selection={componentId}
			className={`buttonDataContainer buttonDataContainer--${blockClass} vtex-add-to-cart-button-0-x-buttonDataContainer vtex-add-to-cart-button-0-x-buttonDataContainer--${blockClass} flex justify-center`}
		>
			{children}
		</div>
	);
};

export default ButtonDataContainer;
